import React from 'react';

import styles from './SimpleButton.module.scss';

const SimpleButton = ({
  outlined,
  title,
  alternate,
  tag,
  className,
  submit
}) => {
  const Tag = tag || 'div';
  return (
    <Tag
      className={`${styles.button} ${outlined ? styles.outlined : ''} ${
        alternate ? styles.alternate : ''
      } ${className}`}
    >
      {title}
    </Tag>
  );
};

export default SimpleButton;
